<div class="external-rates-dialog-component" *ngIf="isDatePickerReady">
  <div class="external-rates-dialog-container">
    <h2>FX Rates</h2>
    <p>
      {{'valuationEventCurrencies.externalRatesDialogFirstPart' | translate}}{{fromCurrencyIsoCode}}{{toCurrencyIsoCode}}{{'valuationEventCurrencies.externalRatesDialogSecondPart' | translate}}
    </p>
    <div class="label-container">{{'valuationEventCurrencies.conversionDate' | translate | uppercase}}</div>
    <div class="label-container angularForm" style="width: 150px;">
      <kendo-datepicker class="datepicker-search-form" [(ngModel)]="conversionDate" [max]="maxDate" style="width: 100%;">
      </kendo-datepicker>
    </div>

  </div>
  <div class="buttons-container">
    <button kendoButton class="addRate" (click)="getRate()">{{'valuationEventCurrencies.getRate' | translate}}</button>
    <button kendoButton class="close" (click)="close()">{{'valuationEventCurrencies.close' | translate}}</button>
  </div>
</div>
